import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type QuizSession = {
   quiz_sessionid: number;
   userid: number;
   quizid: number;
   quiz_revisionid: number;
   response_json: number;
   init_date: number;
   end_date: number;
   score: number;
   passed: boolean;
   cancelled: boolean;
};

export async function saveQuizSession(
   quizid: number,
   response_json: string,
   quiz_revisionid: number,
   langid: string,
   { ...common }: CommonRequestOptions
): Promise<QuizSession> {
   return makeRequest('post', '/quizzes/sessions/save', {
      ...common,
      body: {
         quizid,
         response_json,
         quiz_revisionid,
         langid,
      },
   });
}
